module.exports = __webpack_public_path__ + "assets/e59715c062f60faf4a2582f6fe51980a.svg";